import React from "react";
import { Settings, Home } from "lucide-react";
import Sidebar from "../../components/dashboard/layout/Sidebar";
import FormTable from "../../components/dashboard/forms/FormTable";

const Forms = () => {
    return (
        <div className="flex mx-auto mt-32">
            <Sidebar />
            <div className="flex-1 p-5">
                <h1 className="text-2xl font-bold flex items-center gap-2">
                    <Settings size={24} />
                    Formularios
                </h1>
                <p className="text-gray-700 mt-2 flex items-center gap-2">
                    <Home size={18} />
                    Aquí podrás visualizar la información de los clientes que han llenado los formularios de contacto.
                </p>
                <FormTable />
            </div>
        </div>
    );
};

export default Forms;
